import useGetResolution from '../functions/useGetResolution';
import lapizImg from '../img/lapiz.png';

const TranscribeNotes = () => {
    const resolution = useGetResolution()
    const notes = ["Recuerda que puedes transcribir más de un archivo a la vez siempre que el centro de costos y la cantidad de participantes sea la misma", "Recuerda que puedes optimizar la transcripción en caso de que el audio no tenga mucha calidad"];
    return (
        <div className='notes-transcriptions-box'>
            <div className='flex columns-auto items-center justify-center'>
                {
                    (resolution === "lg" || resolution === "md") && (
                        <img
                            src={lapizImg}
                            alt='notas-img'
                            className='transcribe-notes-logo'
                        />
                    )
                }
                <p className='text-blue notes-title global-font'>Notas</p>
            </div>
            <div className='list-done-transcriptions'>
                {
                    notes.map((file, index) => (
                        <li className='text-blue' key={index}>{file}</li>
                    ))
                }
            </div>
        </div>
    )
}

export default TranscribeNotes;